<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search') || '公式名称/产品线搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openDetailPage', { pageType: 'add' })"
            >
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_formulaTitle') || '公式名称'"
            >
              <el-input v-model="form.formulaTitle" size="small" clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_formulaExplain') || '公式说明'"
            >
              <el-input v-model="form.formulaExplain" size="small" clearable>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_productLine') || '产品线'"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.productLine"
                :body="productLineParams"
                @change="updateCategory"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_categoryName') || '分类'"
            >
              <dict-select
                :disabled="!form.productLine || form.productLine === ''"
                size="small"
                clearable
                filterable
                v-model="form.categoryCode"
                :body="mainMaterialParams"
                url="/master/masterCategory/select"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-col>
                <el-checkbox-group v-model="form.formulaStatusList">
                  <el-checkbox label="Y">
                    {{ $l('INDEX.form_label_valid') || '有效' }}
                  </el-checkbox>
                  <el-checkbox label="N">
                    {{ $l('INDEX.form_label_invalid') || '无效' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  formulaStatusList: ['Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      productLineParams: { dictType: 'productLine' },
      mainMaterialParams: { parentCode: '', isEcom: 'N' },
      form: { ...initForm },
      regionParams: {},
    }
  },
  watch: {
    'form.productLine'() {
      this.mainMaterialParams = {
        parentCode: this.form.productLine,
        isEcom: 'N',
      }
    },
  },
  activated() {
    this.query()
  },

  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    updateCategory() {
      this.form.categoryCode = ''
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form, ...this.regionParams })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      // this.$refs.regionCascader.clearValue()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    multipleChange(val) {
      this.regionParams = { ...val }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
